import { Button, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import arrowIcon from '../../assets/icons/arrowRightOrange.svg';
import noImage from '../../assets/icons/noPhoto.svg';
import image1 from '../../assets/images/images1.jpg';
import newsImage from '../../assets/images/newsImage.png';
import object1 from '../../assets/images/object1.png';
import object2 from '../../assets/images/object2.png';
import object3 from '../../assets/images/object3.png';
import emptyImage from '../../assets/images/profile.png';
import emptyImageServices from '../../assets/images/profileServices.png';
import slide1 from '../../assets/images/slide-home1.jpg';
import slide2 from '../../assets/images/slide-home2.jpg';
import slide_mobile1 from '../../assets/images/slide-home-mobile1.jpg';
import slide_mobile2 from '../../assets/images/slide-home-mobile2.jpg';
import slide_mobile3 from '../../assets/images/slide-home-mobile3.jpg';
import { CustomButton, Icon, Menu } from '../../components';
import { Slider } from '../../components';
import { Card } from '../../components';
import { CustomMenu } from '../../components/Mobile/Menu';
import { useActions } from '../../hooks/useActions';
import { useMain } from '../../hooks/useMain';
import { useUser } from '../../hooks/useUser';
import { ICatalogService } from '../../shared/types/services';

import './Main.sass';
import { getServices } from './utils';

const images = [object1, object2, object3];

//Главная страница
const Main = () => {
  const {
    setDescription,
    setPage,
    setProcesses,
    setTitleTab,
    fetchArticles,
    fetchServices,
    setMenuVisible,
    setOpenMobileCategory,
    fetchMainCatalog,
  } = useActions();
  const { processes, materials, equipments, services, articles } = useMain();
  const { visibleMenuDialog, openMobileCategory } = useUser();
  const [servicesShowMore, setServicesShowMore] = useState(false); //Скрыть/Показать список
  const [handleArticleImg, setHandleArticleImg] = useState(1); //Смена картинки публикаций на другую
  const [servicesContent, setServicesContent] = useState<ICatalogService[]>([]);
  const [servicesLeft, setServicesLeft] = useState<ICatalogService[]>([]);
  //Выводит булевое значение. true - если макс. разрешение меньше 901px, иначе - false
  const mobileScreen = useMediaQuery('(max-width:900px)');
  const handleServicesShowMore = () => {
    setServicesShowMore((prev) => !prev);
  };
  //Показать меню на моб. версии
  const toggleMenuDialog = (category: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuVisible(!visibleMenuDialog);
    setOpenMobileCategory(category);
  };

  useEffect(() => {
    fetchArticles(); //Вызов публикаций
    fetchServices(); //Вызов сервисов
  }, []);

  useEffect(() => {
    setProcesses(processes); //Вызов процессов
    setPage('home'); //На какой мы странице

    setTitleTab('Dazel.ru — интернет магазин | Миллионы технических товаров');
    //Заголовок вкладки страницы

    setDescription(
      'Интернет магазин Dazel — это доступные цены, регулярно обновляемый ассортимент. Крупнейший каталог сайтов товаров и услуг - Dazel.ru'
    );
    //Описание вкладки страницы
  }, [processes]);

  useEffect(() => {
    const handleResize = () => {
      const data = getServices(
        services.catalog_services,
        window.innerWidth > 1496 ? 1464 : window.innerWidth - 32
      );
      setServicesContent(data.content);
      setServicesLeft(data.servicesLeft);
    };
    if (window.innerWidth > 900) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }

    return () => window.removeEventListener('resize', handleResize);
  }, [services]);

  return (
    <div className="main-page">
      <section className="main-page-top main-page-top_desktop desktop">
        <Menu
          title="Материалы"
          catalogType="materials"
          className="left"
          menuItems={
            materials?.map((material) => ({
              type: 'li',
              item: material,
            })) || []
          }
          article={null}
          placement="right-start"
        />
        <Slider
          slides={[
            <img src={slide1} alt="slide" />,
            <img src={slide2} alt="slide" />,
          ]}
          className="main-page__slider"
          autoHeight
          loop
          autoplay
        />
        <Menu
          title="Оборудование"
          catalogType="equipment"
          menuItems={
            equipments?.map((equipment) => ({
              type: 'li',
              item: equipment,
            })) || []
          }
          article={null}
          placement="left-start"
        />
      </section>
      <section className="main-page-top main-page-top_mobile mobile">
        <Slider
          slides={[
            /*<img src={slide_mobile1} alt="slide" />,*/
            <img src={slide_mobile2} alt="slide" />,
            <img src={slide_mobile3} alt="slide" />,
          ]}
          className="main-page__slider mobile"
          autoHeight
          loop
          autoplay
        />
        <div className="main-page-buttons">
          <CustomMenu openCategory={openMobileCategory} />
          <Button onClick={() => toggleMenuDialog('materials')}>
            Материалы <Icon variant="arrowRightOrange" />
          </Button>
          <Button onClick={() => toggleMenuDialog('equipments')}>
            Оборудование <Icon variant="arrowRightOrange" />
          </Button>
        </div>
      </section>
      {/*<section className="services services_desktop desktop">
        <div className="services__top">
          <h1>Каталог услуг из 1000 специалистов</h1>
          <img src={image1} alt="" />
          <CustomButton variant="outlined" className="basket_active">
            Скоро открытие
          </CustomButton>
        </div>

        <div className="services__catalog">
          <div className="services__line services__line_desktop">
            <ul>
              {servicesContent.map((service, index) => (
                <React.Fragment key={service.id}>
                  <li>{service.title}</li>
                  {index < servicesContent.length - 1 && (
                    <div className="services__divider" />
                  )}
                </React.Fragment>
              ))}
            </ul>
            {servicesShowMore && (
              <ul>
                {servicesLeft
                  ? servicesLeft.map((service, index) => (
                      <React.Fragment key={service.id}>
                        <li>{service.title}</li>
                        {index < servicesLeft.length - 1 && (
                          <div className="services__divider" />
                        )}
                      </React.Fragment>
                    ))
                  : null}
              </ul>
            )}
          </div>
          <CustomButton variant="orange">
            {servicesShowMore ? <>Скрыть список</> : <>Весь список</>}
            <div
              className={
                'services__icon ' + (servicesShowMore ? 'rotate180deg' : '')
              }
            >
              <Icon variant="arrowDownWhite" />
            </div>
          </CustomButton>
        </div>
        <div className="services__cards services__cards_desktop">
          {services
            ? services.service_profile_list.map((service) => (
                <Card key={service.id} className="service">
                  <div className="service-card service-card_desktop">
                    <div className="service-card__top">
                      <img
                        src={emptyImage || service.img}
                        alt="img"
                        className="service-card__image"
                      />
                      <div>
                        <h3 className="service-card__title">
                          {service.org_name ||
                            service.firstname +
                              ' ' +
                              service.middlename +
                              ' ' +
                              service.surname}
                        </h3>
                        <div className="service-card__description service-card__description_desktop">
                          {service.description}
                        </div>
                      </div>
                    </div>
                    <div className="service-card__bottom">
                      <p>
                        {
                          service.service_profile_catalog_list[0]
                            .knowledge_services.title
                        }
                      </p>
                      <div className="service-card__underline" />
                      <p>
                        {service.service_profile_catalog_list[0].price_kopecks /
                          100}{' '}
                        ₽
                      </p>
                    </div>
                  </div>
                </Card>
              ))
            : null}
        </div>
      </section>*/}
      <section className="services services_mobile mobile">
        <div className="services__title mobile">
          <h1>Специалисты</h1>
          <Icon variant="arrowRightOrange" />
        </div>
        <div className="services__line services__line_mobile">
          <ul>
            {services.catalog_services.map((service) => (
              <CustomButton variant="outlined" key={service.id}>
                {service.title}
              </CustomButton>
            ))}
          </ul>
        </div>
        <div className="services__cards services__cards_mobile">
          {services.service_profile_list.map((service) => (
            <Card key={service.id} className="service">
              <div className="service-card service-card_mobile">
                <img src={service.img || emptyImageServices} alt={'img'} />
                <div className="service-card__desciption service-card__description_mobile">
                  <h3>
                    {service.org_name ||
                      service.firstname +
                        ' ' +
                        service.middlename +
                        ' ' +
                        service.surname}
                  </h3>
                  <p>
                    {
                      service.service_profile_catalog_list[0].knowledge_services
                        .title
                    }
                  </p>
                  <p>
                    {service.service_profile_catalog_list[0].price_kopecks /
                      100}{' '}
                    ₽
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
        {!mobileScreen && <p className="services__show-more">Посмотреть все</p>}
      </section>
      <section className="articles articles_desktop desktop">
        <div className="articles-top">
          <h1>База знаний</h1>
          <Link to="/articles">
            <div className="articles-top__right">
              <p>Перейти в базу знаний</p>
              <img src={arrowIcon} alt="icon" />
            </div>
          </Link>
        </div>
        <div className="articles__cards articles__cards_desktop">
          {articles
            ? articles.map((article) => {
                return (
                  <Link key={article.id} to={`articles/${article.slug}`}>
                    <Card className="article">
                      <div
                        /*onMouseLeave={() => handleLeaveArticle(0)}*/
                        /* onMouseMove={() => handleMoveArticle(article.id)}*/
                        onClick={() =>
                          window.scrollTo({ top: 0, behavior: 'auto' })
                        }
                        className={
                          article?.img
                            ? 'article-card article-card_desktop'
                            : 'article-card article-card_desktop custom'
                        }
                      >
                        {article?.img ? (
                          <div className="article-card__block">
                            <img src={article.img} alt="img" />
                          </div>
                        ) : (
                          <div className="article-card__block custom">
                            <img src={noImage} alt="img" />
                          </div>
                        )}
                        <div className="article-card__left">
                          <p className="article-card__tag article-card__tag_desktop">
                            {article.topic_type === 'Knowledge::Materials'
                              ? 'Материалы'
                              : 'Knowledge::Equipment'
                              ? 'Оборудование'
                              : 'Процессы'}
                          </p>
                          <p className="article-card__title article-card__title_desktop">
                            {article.title}
                          </p>
                        </div>
                      </div>
                    </Card>
                  </Link>
                );
              })
            : null}
        </div>
      </section>
      <section className="articles articles_mobile mobile">
        <div className="articles__title mobile">
          <h1>База знаний</h1>
          <Icon variant="arrowRightOrange" />
        </div>
        <div className="articles__cards articles__cards_mobile">
          {articles
            ? articles.map((article) => (
                <Card key={article.id}>
                  <div className="article-card article-card_mobile">
                    <img src={article.img || emptyImageServices} alt="img" />
                    <div className="article-card__description article-card__description_mobile">
                      <p className="article-card__tag article-card__tag_mobile">
                        {article.topic_type === 'Knowledge::Materials'
                          ? 'Материалы'
                          : 'Knowledge::Equipment'
                          ? 'Оборудование'
                          : 'Процессы'}
                      </p>
                      <p className="article-card__title article-card__title_mobile">
                        {article.title}
                      </p>
                    </div>
                  </div>
                </Card>
              ))
            : null}
        </div>
        {!mobileScreen && (
          <p className="articles__show-more">Перейти в базу знаний</p>
        )}
      </section>
      <section className="banners banners_desktop desktop">
        <div className="banner banner_big">
          <div className="banner__date">С 15 Ноября</div>
          <div className="banner__title">
            Марафон <span>скидок</span>
          </div>
          <img src={newsImage} alt="img" />
        </div>
        {/*<div className="banners__bottom">
          {images.map((image, index) => (
            <div className="banner banner_small">
              <h1>Установка - станок для алмазного сверления</h1>
              <img src={image} alt="img" />
            </div>
          ))}
        </div>*/}
      </section>
      <section className="banners banners_mobile mobile">
        <Slider
          slides={images.map((image, index) => (
            <div key={`${image}_${index}`} className="banner banner_slide">
              <h1>Установка - станок для алмазного сверления</h1>
              <img src={image} alt="img" />
            </div>
          ))}
        />
      </section>
    </div>
  );
};

export default Main;
